import * as LF from "leaflet";
import 'leaflet/dist/leaflet.css'
import 'leaflet.fullscreen'
import 'leaflet.fullscreen/Control.FullScreen.css'
import 'leaflet.utm'

import {useEffect, useState} from "react";
import UgSpatial from "../../../ug/ug_spatial";
import Basemap from "../../../ug/basemap";
import pullVillageBoundary from "./ugeoserver";
import GeoServer from "../../../service/geoserser";
import PopDetail from "../../popdetail";
import AddDocumentPane from "../../add/add_document";
import Wait from "../../wait";
import {ProjectsService as ReadService} from "../../../service/v1/projects";
import api from "../../../service/api";

export default function FormalizationInputMap(props){

    const [projectId] = useState(props.project.id)
    const [villages,setVillages] = useState([{name:'Buduba',id:234}])
    const [attachedDocuments,setAttachedDocuments] = useState([])
    const [requiredDocuments,setRequiredDocuments] = useState([])

    useEffect(()=>{
        loadMap().then(r => {
            console.log('map loaded')

        })

        loadData()
    },[])


    const loadData =()=> {

        try {
            Wait.show('Fetching Documents....')
            ReadService.fetchRequiredDocuments(props.project.id,props.taskId).then(r => {
                Wait.dismiss()
                try {
                    setAttachedDocuments(r.data.attached_documents)
                    setRequiredDocuments( r.data.required_documents)
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            Wait.dismiss()
            console.log(e)
        }
    }

    const showDoc =(d)=>{

    }

    const deleteDoc =(d)=>{

    }

    async function loadMap() {

        UgSpatial.clear()
        let self = this
        let ly_labels = new LF.FeatureGroup(),
            ly_beacons = new LF.FeatureGroup(),
            ly_plots = new LF.FeatureGroup()
        let sat = Basemap.googleSat(),
            hybrid = Basemap.googleHybrid(),
            gray = Basemap.backWhite(),
            blank = LF.tileLayer('')

        let map = LF.map('map', {
            layers: [sat,ly_plots, ly_labels],
            attributionControl: false,
            fullscreenControl: true,
            fullscreenControlOptions: {
                position: 'topleft'
            },
            maxZoom:10000
        }).setView([-6.085936, 35.711995], 6)


        let baseLayers = {
            'Gray':gray,
            "<span style='color: gray'>Blank</span>": blank,
            "Satellite": sat,
            "Hybrid": hybrid
        }


        let filter = 'project_id='+projectId
        let layername = 'project_parcel'

        let selected = ''


        Wait.show("Loading Spatial...")
        api.get(GeoServer.API_URL+'/ows?cql_filter='+filter+'&service=WFS&version=1.0.0&request=GetFeature&typeName='+layername+'&outputFormat=application%2Fjson').then(r=>{
            Wait.dismiss()
            try {
                        //console.log(r.data)
                        r.data.features.forEach(p=>{

                            let myLayer = LF.geoJSON(p,{
                                onEachFeature:(f,l)=>{
                                    LF.marker(l.getBounds().getCenter(),{
                                        icon:LF.divIcon({
                                            className:'bindTooltipBig',
                                            html:f.properties.claim_no,
                                            iconSize:[100,40]
                                        })
                                    }).addTo(ly_labels)
                                    l.setStyle({
                                        color:f.properties.status==='occupied'?'#000':'#f80',
                                        fillColor:f.properties.status==='occupied'?'#000':'#f80',
                                         fillOpacity: f.properties.status==='occupied'?0.4:0,
                                    })
                                },
                                coordsToLatLng: function (coords) {
                                    return LF.utm({x: coords[0], y: coords[1], zone: 36, band: 'M'}).latLng();
                                },
                                weight:3,zIndex:2,

                            }).on('dblclick',e=>{


                            }).on('click', function (e) {

                                if (e.layer.feature.properties.status==="occupied"){
                                    alert('Occupied')
                                    return
                                }
                                selected = e.layer
                                selected.bringToFront()

                            })
                            myLayer.addTo(ly_plots)
                        })

                        let myLayer = LF.geoJSON(r.data,{coordsToLatLng: function (coords) {return LF.utm({x: coords[0], y: coords[1], zone: 36, band: 'M'}).latLng();}})
                        //let myLayer = LF.geoJSON(r.data)
                        //myLayer.addTo(ly_plots)


                        try{ map.fitBounds(myLayer.getBounds())}catch (e) { }
                    }catch (e){
                        console.log(e)
                    }
        })


      /*  layername = 'point_spatial'
        api.get(GeoServer.API_URL+'/ows?cql_filter='+filter+'&service=WFS&version=1.0.0&request=GetFeature&typeName='+layername+'&outputFormat=application%2Fjson').then(r=>{
            Wait.dismiss()
            try {
                        ///console.log(r.data)
                        r.data.features.forEach(p=>{
                            let myLayer = LF.geoJSON(p,{
                                onEachFeature:(f,l)=>{
                                    //console.log(l._latlng)
                                    LF.marker(l._latlng,{
                                        icon:LF.divIcon({
                                            className:'bindTooltipBig',
                                            html:f.properties.description,
                                            iconSize:[100,40]
                                        })
                                    }).addTo(ly_beacons)
                                   /!* l.setStyle({
                                        color:f.properties.status==='Approved'?'#00ff00':'#901'
                                    })*!/
                                },
                                /!*coordsToLatLng: function (coords) {
                                    return LF.utm({x: coords[0], y: coords[1], zone: 36, band: 'M'}).latLng();
                                },*!/
                                weight:3,zIndex:2, fillOpacity: 0
                            }).on('dblclick',e=>{


                            }).on('click', function (e) {


                            })
                            //myLayer.addTo(ly_group)
                        })
                    }catch (e){
                        console.log(e)
                    }
        })
*/

        let overlays = {
            'Plots':ly_plots,
            'Labels':ly_labels,
            'Beacons':ly_beacons,

        }


        UgSpatial.layers = LF.control.layers(baseLayers,overlays, {position: 'bottomleft'}).addTo(map)

        let legend = LF.control({position: 'bottomright'});
        legend.onAdd = function (map) {
            let div = LF.DomUtil.create('div', 'info legend');
            div.innerHTML = '<img width="100px" src="'+GeoServer.API_URL+'/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=spatial_unit" alt="legend"/>';

            return div;
        };
        legend.addTo(map);

        map.options.minZoom = 12;
        //map.options.maxZoom = 14;
        LF.control.scale().addTo(map);
        return map
    }


    return (<div>
            <div className={'row'}>

                <div style={{padding: '16px', background: '#efefef', position: 'sticky', top: 0, zIndex: 2}}>
                     <span style={{fontSize: '16px'}}>
                        <span className={'fa fa-map'} style={{marginRight: '8px'}}/>Map View
                    </span>


                    <span style={{fontSize: '12px', float: 'right'}}>
                        <span className={'fa fa-history'} style={{marginRight: '11px', marginLeft: '4px'}}/>Updated 28 Minutes Ago
                    </span>

                </div>

            </div>

            <div className={'row'}>
                <div className={'col col-sm-3'} style={{height: '80vh', padding: 0}}>

                    <div className={'col col-sm-12'}
                         style={{height: '50%', borderBottom: '1px solid #ccc', padding: 0}}>
                        <div style={{fontSize: '16px', background: 'linear-gradient(#fff,#ccc)', padding: '4px 24px'}}>
                            <span className={'fa fa-paperclip'}/>Required Maps
                        </div>
                        <div style={{margin: '16px'}}>
                            {requiredDocuments.map((d, i) => {
                                return (<div className={'sub-menu'} onClick={()=>PopDetail.show(d.name,<AddDocumentPane document={d} screen_code={props.screen_code}
                                                                                                                        taskId={props.taskId}
                                                                                                 project={props.project} loadData={loadData}
                                                                                                 key={new Date().getMilliseconds()}/>,40)}
                                             key={i} style={{color:'darkcyan', float:'left',margin:0,width:'100%',padding:'4px'}} title={d.description}>
                                    <span className={'fa fa-times'}/>
                                    {d.name}

                                    <span className={'fa fa-plus'} style={{
                                                float: 'right',
                                                color: '#00984b',
                                                fontSize: '18px'
                                            }}/>
                                </div>)
                            })}

                        </div>
                    </div>

                    <div className={'col col-sm-12'}
                         style={{height: '50%', padding: 0}}>
                        <div style={{fontSize: '16px', background: 'linear-gradient(#fff,#ccc)', padding: '4px 24px'}}>
                            <span className={'fa fa-paperclip'}/>Uploaded Maps
                        </div>

                        <div style={{margin: '16px'}}>
                            {attachedDocuments.map((d, i) => {
                                return (<div className={'sub-menu'}
                                             key={i} style={{color:'darkcyan',float:'left',margin:0,width:'100%',padding:'4px'}} title={d.description}>
                                    <span className={'fa fa-check'}/>

                                    <span onClick={() => showDoc(d)}>
                                        {d.name}
                                    </span>
                                    <span className={'fa fa-trash'} onClick={() => deleteDoc(d)}
                                          style={{float: 'right', color: '#f00', fontSize: '18px'}}/>
                                </div>)
                            })}
                        </div>
                    </div>


                </div>
                <div className={'col col-sm-9'} style={{height: '83vh',background:'#282828', padding: 0, borderLeft: '1px solid #ccc'}}>
                    <div style={{width: '100%', border: '1px solid #ccc', height: '87vh'}} id={'ramani'}/>
                </div>


            </div>

        </div>)


    /*return (<div>

        <div className={'row'} style={{background: '#efefef', position: 'sticky', top: 0, zIndex: 2}}>
            <div className={'col col-sm-2'}>
                <div style={{fontSize: '16px', padding: '16px', fontWeight: 'bold'}}>
                    <span className={'fa fa-info'} style={{marginRight: '8px'}}/>
                    MapView
                </div>
            </div>

        </div>
        <div className={'row'}>
            <div className={'col col-sm-9'} style={{padding: 0}}>
                <div style={{width: '100%', border: '1px solid #ccc', height: '87vh'}} id={'ramani'}/>
            </div>
            <div className={'col col-sm-3'} style={{height: '87vh'}}>
                <div className={'label'} style={{padding: '8px 0'}}>
                    Required Maps
                </div>
                {villages.map((v, i) => {
                    return (
                        <table key={i} className={'tb'} style={{width: '100%', fontSize: '12px'}}>
                            <thead>
                            <tr>
                                <th style={{fontSize: '12px'}}>{v.name} Village</th>
                                <th style={{fontSize: '12px'}}>Status</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td style={{fontSize: '12px'}}>
                                    <span className={'fa fa-check'}/>Village Boundary
                                </td>
                                <td style={{fontSize: '12px', width: '100px'}}>
                                    <button className={'default'}>Upload</button>
                                </td>
                            </tr>
                            <tr>
                                <td style={{fontSize: '12px'}}>
                                    <span className={'fa fa-times'}/>Hamlet Boundary
                                </td>
                                <td style={{fontSize: '12px', width: '100px'}}>
                                    <button className={'default'}>Upload</button>
                                </td>
                            </tr>
                            </tbody>
                        </table>)
                })}
            </div>

        </div>

    </div>)*/;


}